"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NamePlateReportPageActions;
(function (NamePlateReportPageActions) {
    NamePlateReportPageActions["DataLoaded"] = "DataLoaded";
})(NamePlateReportPageActions || (NamePlateReportPageActions = {}));
exports.default = NamePlateReportPageActions;
